export default [
	{
		path: '/account-selection',
		name: 'account.selection',
		component: () => import(/* webpackChunkName: "AccountSelection" */ './AccountSelection'),
	}
]
